<ion-modal
  [isOpen]="isOpen"
  [canDismiss]="isDismissable"
  (didDismiss)="onDismiss.emit()"
  mode="md"
  id="modal"
>
  <ng-template>
    <ng-content></ng-content>
  </ng-template>
</ion-modal>
